import React from "react";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import UniversalLineChartComponent from "../../../../Universal/UniversalLineChartComponent";
import "../../../../../styles/Pages/Financial/Accountant/Liabilities/LiabilitiesLineChart.style.css";

const LiabilitiesLineChart = ({ graphData }) => {
  return (
    <div className="liabilitiesLineChartComponent">
      <div className="graphHeader">
        <h3>Total liability</h3>
        <SelectFilter />
      </div>
      <div className="graphContent">
        <UniversalLineChartComponent
          data={graphData}
          lines={[
            {
              dataKey: "liabilities",
              name: "Liabilities",
              stroke: "#FF5733",
            },
          ]}
          xAxisKey="name"
          referenceLinesStep={1000}
        />
      </div>
    </div>
  );
};

export default LiabilitiesLineChart;
